import React from 'react';

import styles from './backdrop.module.scss';

interface Props {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  callback?: () => void;
  isTransparent?: boolean;
  closeOnClick?: boolean;
}

const Backdrop: React.FC<Props> = (props) => {
  const { visible, setVisible, isTransparent, closeOnClick = true } = props;

  return visible ? (
    <div
      className={styles.container}
      style={{
        backgroundColor: isTransparent ? 'transparent' : 'rgba(0, 0, 0, 0.8)',
      }}
      onClick={(e) => {
        e.stopPropagation();
        if (!closeOnClick) return;
        setVisible(!visible);
        // if (callback) callback();
      }}
    />
  ) : null;
};

export default Backdrop;
